/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getUploadLimits.defs.js'
export { main as default } from './getUploadLimits.defs.js'
